import PropTypes from "prop-types"
import classnames from "classnames"
import { DATE } from "helpers/shapes"
import { formatLongDate } from "helpers/formatters/dates"
import { METRIC_TYPES_SHAPE } from "helpers/metrics/shapes"
import DailyDetails from "./components/daily-details"
import ContributorsDetails from "modules/performance-contributors"
import "./style.scss"

function AnalyzePerformanceDetails({
  selectedDate,
  selected,
  selectedValue,
  viewType,
  selectedOption,
  show,
  hide,
  sort,
  details,
  order,
  openSecurityProfile,
  openFactorProfile,
  contributorsGrouping,
  setContributorsGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  groupSort,
  groupOrder,
  toggleShowNotHeld,
  selectedViews,
  metricType,
}) {
  return <div className={classnames("modules_analyze-performance-details")}>
    <h4 className="header">As of {formatLongDate(selectedDate)}</h4>
    {!selected
      ? <DailyDetails {...{
          viewType,
          openFactorProfile,
          factorTable: selectedOption.id !== "total" && selectedOption.id !== "factors",
          data: details,
          show,
          groupSort,
          groupOrder,
          metricType,
        }}
      />
      : <ContributorsDetails {...{
          selectedDate,
          viewType,
          openSecurityProfile,
          openFactorProfile,
          hide,
          sort,
          order,
          selected,
          selectedValue,
          showGroup,
          hideGroup,
          selectedGroup,
          setContributorsGrouping,
          contributorsGrouping,
          selectedOption,
          toggleShowNotHeld,
          details,
          show,
          groupOrder,
          selectedViews,
          metricType,
        }}
      />}
  </div>
}

AnalyzePerformanceDetails.propTypes = {
  selectedDate: DATE.isRequired,
  selected: PropTypes.object,
  selectedValue: PropTypes.number.isRequired,
  details: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  selectedOption: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  show: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
  sort: PropTypes.func.isRequired,
  contributorsGrouping: PropTypes.object,
  setContributorsGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  filtersVisible: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  toggleShowNotHeld: PropTypes.func.isRequired,
  selectedViews: PropTypes.array,
  metricType: METRIC_TYPES_SHAPE.isRequired,
}

export default AnalyzePerformanceDetails
